import React, {useEffect} from 'react';
import styles from './top-row.module.scss';
import SearchForm from './search-form';
import Logo from '../logo';
import {Link} from 'react-router-dom';
// import Basket from "@/layouts/partials/header/basket";
import {useSelector} from "react-redux";
import {ROLES} from "@/constants";

type Props = {
  basketCount: number
};

const TopRow: React.FC<Props> = ({ basketCount }) => {
    const user = useSelector((state: any) => state.auth.user);
    return (
    <div className={styles.topRow + " row align-items-center mb-lg-0 py-3"}>
      <div className={styles.logoContainer + " col-lg-2 col-md-6 col-sm-5 col-6 mb-2"}>
        <Logo />
      </div>
      <div className="col-lg-4 px-lg-0 d-lg-block d-none">
        <SearchForm />
      </div>
      <div className="col-lg-6 col-md-6 col-sm-7 col-6 text-start d-flex justify-content-end">
        <div className={styles.buttonsContainer + " d-sm-inline-block d-none ps-3"}>
            {user ? (
                <>
                  <Link to="/logout" className="btn btn-danger ms-2">خروج</Link>
                  <a href={user.role === ROLES.ADMIN ? "/admin/dashboard" : "/profile"} className={styles.btnLogin + " btn"}>پروفایل من</a>
                </>
            ) : (
                <>
                  <Link to="/login" className="btn btn-primary ms-2">ثبت آگهی</Link>
                  <Link to="/login" className={styles.btnLogin + " btn"}>ثبت نام / ورود</Link>
                </>
            )}
        </div>
        <div className={styles.buttonsContainer + " d-sm-none d-inline-block ps-4"}>
          {user ? (
              <a href={user.role === ROLES.ADMIN ? "/admin/dashboard" : "/profile"} className="text-primary d-flex">
                <i className="fa fa-user" />
              </a>
          ) : (
              <Link to="/login" className="text-primary d-flex">
                <i className="fa fa-user" />
              </Link>
          )}
        </div>
        {/*<Basket />*/}
      </div>
    </div>
  );
}

export default TopRow;